import './App.css';
import Home from './components/home';
import Project from './components/project';
import { Route, Routes } from 'react-router-dom';

function App() {
  return (
    <div>
    <div>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/project" element={<Project/>} />
      </Routes>
    </div>
    </div>
  );
}

export default App;
